import { motion } from "framer-motion";

// Removed duplicates - Siemens was in both lists
const partners = [
  "ABB",
  "Alpitronics",
  "Autel",
  "BTC Power",
  "Delta",
  "EVBox",
  "Ekoenergetyka",
  "FLO",
  "Heliox",
  "i-Charging",
  "Power Electronics",
  "Signet",
  "Siemens",
  "Samsung EVSIS",
  "Tellus Power",
  "Tritium",
  "Liteon",
  "Wallbox",
];

const clients = [
  "LA Metro",
  "Microsoft",
  "BC Hydro",
  "NV Energy",
  "City of Toronto",
  "Broward County",
  "UCLA",
  "Southern California Edison",
  "Daimler",
];

export function PartnersSectionNew() {
  // Duplicate for seamless loop
  const duplicatedPartners = [...partners, ...partners];
  const duplicatedClients = [...clients, ...clients];

  return (
    <section className="py-10 relative overflow-hidden bg-card">
      {/* Subtle top/bottom borders */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        {/* Section Label */}
        <motion.div 
          className="text-center"
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
            Trusted by Industry Leaders
          </span>
        </motion.div>

        {/* Hardware Partners */}
        <div className="space-y-4">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-white/10" />
            <span className="text-xs text-white/70 uppercase tracking-wider font-medium px-4">
              Hardware Partners
            </span>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-white/10" />
          </div>

          <div className="relative overflow-hidden">
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-card via-card/50 to-transparent z-10 pointer-events-none" />
            <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-card via-card/50 to-transparent z-10 pointer-events-none" />
            
            <motion.div
              className="flex items-center gap-16"
              animate={{
                x: ["0%", "-50%"],
              }}
              transition={{
                x: {
                  duration: 35,
                  repeat: Infinity,
                  ease: "linear",
                },
              }}
            >
              {duplicatedPartners.map((partner, idx) => (
                <motion.span
                  key={idx}
                  className="text-white/70 font-semibold text-xl hover:text-primary transition-colors duration-300 whitespace-nowrap cursor-default flex-shrink-0"
                  whileHover={{ scale: 1.05 }}
                >
                  {partner}
                </motion.span>
              ))}
            </motion.div>
          </div>
        </div>

        {/* Trusted Clients */}
        <div className="space-y-4">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-white/10" />
            <span className="text-xs text-white/70 uppercase tracking-wider font-medium px-4">
              Enterprise Clients
            </span>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-white/10" />
          </div>

          <div className="relative overflow-hidden">
            <div className="absolute left-0 top-0 bottom-0 w-24 bg-gradient-to-r from-card via-card/50 to-transparent z-10 pointer-events-none" />
            <div className="absolute right-0 top-0 bottom-0 w-24 bg-gradient-to-l from-card via-card/50 to-transparent z-10 pointer-events-none" />
            
            <motion.div
              className="flex items-center gap-16"
              animate={{
                x: ["-50%", "0%"],
              }}
              transition={{
                x: {
                  duration: 30,
                  repeat: Infinity,
                  ease: "linear",
                },
              }}
            >
              {duplicatedClients.map((client, idx) => (
                <motion.span
                  key={idx}
                  className="text-white/70 font-semibold text-xl hover:text-accent transition-colors duration-300 whitespace-nowrap cursor-default flex-shrink-0"
                  whileHover={{ scale: 1.05 }}
                >
                  {client}
                </motion.span>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}